import { render, staticRenderFns } from "./GroupMgmt.vue?vue&type=template&id=2edd38c4&scoped=true"
import script from "./GroupMgmt.vue?vue&type=script&lang=js"
export * from "./GroupMgmt.vue?vue&type=script&lang=js"
import style0 from "./GroupMgmt.vue?vue&type=style&index=0&id=2edd38c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd38c4",
  null
  
)

export default component.exports